import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from './store/'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import './permission' // permission control
import Antd, { Carousel,Collapse } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

// 引入moment并设置中文语言
import moment from 'moment'
import 'moment/locale/zh-cn'

// 设置moment为中文
moment.locale('zh-cn')

Vue.use(Antd)
Vue.use(Carousel)
Vue.use(Collapse)

Vue.config.productionTip = false

let tokenSyncTimer = null
window.addEventListener('storage', event => {
  if (event.key !== ACCESS_TOKEN) {
    return
  }
  clearTimeout(tokenSyncTimer)
  tokenSyncTimer = setTimeout(() => {
    store.commit('SET_TOKEN', storage.get(ACCESS_TOKEN) || '')
    window.location.reload()
  }, 100)
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
